import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'number-editor',
  templateUrl: './number-editor.component.html',
  styleUrls: ['./number-editor.component.scss']
})
export class NumberEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
